import Button, { ButtonProps } from '@/components/blocks/Button';

export interface ButtonGroupProps {
	buttons: ButtonProps[];
	className?: string;
	theme?: 'light' | 'orange' | 'blue' | 'dark' | 'seaweed';
}

const ButtonGroup = ({ buttons, className, theme = 'light' }: ButtonGroupProps) => {
	return (
		<div className={`flex flex-wrap gap-4 ${className || ''}`}>
			{buttons?.map((button) => <Button key={button.id} {...button} buttonTheme={theme} />)}
		</div>
	);
};

export default ButtonGroup;
